export default __webpack_public_path__ + "static/media/microsoft-windows.680a11ac.svg";